export default __webpack_public_path__ + "static/street-113b59d3e8eaaccb3fc8ef46519ffdc0.webp";